import './radio-group.css';

import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import * as React from 'react';

import { cn } from '@/services/utils';

const RadioGroup = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => {
    return (
        <RadioGroupPrimitive.Root
            className={cn('tw-grid tw-gap-8', className)}
            {...props}
            ref={ref}
        />
    );
});

RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

const RadioGroupItem = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, ...props }, ref) => {
    return (
        <RadioGroupPrimitive.Item
            ref={ref}
            className={cn(
                `scoped-radio-group
                 tw-flex
                 tw-items-center
                 tw-justify-center
                 tw-aspect-square
                 tw-h-4 tw-w-4
                 tw-rounded-full
                 tw-border
                 tw-bg-white
                 disabled:tw-cursor-not-allowed
                 disabled:tw-border-primary
                 disabled:tw-bg-fill-secondary`,
                className
            )}
            {...props}
        >
            <RadioGroupPrimitive.Indicator className="tw-flex tw-items-center tw-justify-center">
                <div className="tw-h-2.5 tw-w-2.5 tw-rounded-full tw-bg-current"></div>
            </RadioGroupPrimitive.Indicator>
        </RadioGroupPrimitive.Item>
    );
});

RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

export { RadioGroup, RadioGroupItem };
